import * as React from "react";
import type { TenantTagSetsOrCustomFieldsProps, TenantTagSetsOrCustomFieldsQueryParams } from "~/areas/library/components/TenantTagSets/TenantTagSetsOrCustomFields";
import { TenantTagSetsOrCustomFields } from "~/areas/library/components/TenantTagSets/TenantTagSetsOrCustomFields";
export type TenantTagSetsPageProps = TenantTagSetsOrCustomFieldsProps;
export type TenantTagSetsPageQueryParams = TenantTagSetsOrCustomFieldsQueryParams;
export function TenantTagSetsPage({ spaceId, queryParams, setQueryParams, loaderData }: TenantTagSetsPageProps) {
    return <TenantTagSetsOrCustomFields spaceId={spaceId} queryParams={queryParams} setQueryParams={setQueryParams} loaderData={loaderData}/>;
}
